import { render } from "./EditPeppolDocuments.vue?vue&type=template&id=0b8276bc&scoped=true"
import script from "./EditPeppolDocuments.vue?vue&type=script&lang=js"
export * from "./EditPeppolDocuments.vue?vue&type=script&lang=js"

import "./EditPeppolDocuments.vue?vue&type=style&index=0&id=0b8276bc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b8276bc"]])

export default __exports__